import { Carousel, type CarouselProps } from '@/components/Carousel'
import { PanelItem, type PanelItemProps } from '@/components/List/Panel'

export interface ListMediasProps {
  items: PanelItemProps[]
  carousel?: CarouselProps[]
}

const ListMedias = ({ items }: ListMediasProps) => {
  if (!items) {
    return null
  }

  return (
    <Carousel visibleCountDesktop={3} visibleCountMobile={1}>
      {items &&
        items.map((item, index) => (
          <PanelItem key={`lm_item_${index}`} {...item} layout="fixed" width={294} height={200} />
        ))}
    </Carousel>
  )
}

export default ListMedias
